import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.wallet,
    props.app.bitcoin_cashout,
    props.app.buttons.create_bitcoin_cashout,
    props.app.buttons.confirm_bitcoin_cashout,
    (wallet, cashout_request, create_button, confirm_button) => {
        return {
            wallet,
            cashout_request,
            create_button,
            confirm_button
        }
    }
)